const transformEmptyArraysToObjects = (props) =>
    Object.entries(props).reduce((acc, [property, value]) => {
        acc[property] = value;

        if (Array.isArray(value) && !value.length) {
            acc[property] = {};
        }

        return acc;
    }, {});

export function transformStructureDataForEditor(data = {}, stateNodeIdPrefix) {
    const structure = data || {};

    return {
        ...Object.entries(structure).reduce(
            (acc, [nodeName, nodeConfig]) => ({
                ...acc,
                // Remove the props object from every property and put the properties one level up
                [`${stateNodeIdPrefix}_${nodeName}`]: transformEmptyArraysToObjects(nodeConfig.props),
            }),
            {},
        ),
    };
}
